// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_tabs__6huo-","tabs_header":"tabs_tabs_header__1JWSB","active":"tabs_active__3ZPTt","tabs_body":"tabs_tabs_body__2-SB1"};